<template>
  <div class="px-2 flex items-center">
    <svg class="w-[18px] mr-1 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 62.964">
      <path
        d="M23.383,47.011H69.41A14.247,14.247,0,1,0,55.162,32.764a2.5,2.5,0,1,0,5,0,9.246,9.246,0,1,1,9.248,9.247H23.383a2.5,2.5,0,1,0,0,5Zm59.869,5.978H5a2.5,2.5,0,0,0,0,5H83.252A9.247,9.247,0,1,1,74,67.235a2.5,2.5,0,0,0-5,0A14.248,14.248,0,1,0,83.252,52.989Z"
        transform="translate(-2.5 -18.518)" />
    </svg>

    <svg v-if="WindDirection != 0" class="fill-current w-[10px] mr-1" :class="{
      'rotate-[0deg]': 1,
      'rotate-[45deg]': WindDirection == 2,
      'rotate-[90deg]': WindDirection == 3,
      'rotate-[135deg]': WindDirection == 4,
      'rotate-[180deg]': WindDirection == 5,
      'rotate-[225deg]': WindDirection == 6,
      'rotate-[270deg]': WindDirection == 7,
      'rotate-[315deg]': WindDirection == 8,
    }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.69 56.28">
      <path
        d="M45.78,21.16s-.02-.02-.04-.04L25.57.93c-1.24-1.24-3.24-1.24-4.48,0L.91,21.12c-1.22,1.25-1.21,3.25.04,4.48,1.23,1.21,3.21,1.21,4.44,0l14.78-14.79v42.31c0,1.75,1.42,3.17,3.17,3.17s3.17-1.42,3.17-3.17V10.84l14.75,14.76c1.22,1.25,3.23,1.27,4.48.04,1.25-1.22,1.27-3.23.04-4.48Z" />
    </svg>

    {{ WindSpeed }} km/h
  </div>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    WindSpeed() {
      return this.config?.drone?.status?.wind_speed != undefined
        ? (parseFloat(this.config.drone?.status.wind_speed) * 3.6 / 10).toFixed(1)
        : ENV.NO_DATA;
    },

    WindDirection() {
      return this.config?.drone?.status?.wind_direction != undefined
        ? this.config.drone.status.wind_direction
        : 0
    }
  },
};
</script>
